<template>
  <div class="tasks">
    <cards-layout
      cardsType="Tâches"
      headerText="Tâches"
      :cards="[]"
    />
  </div>
</template>

<script setup lang="ts">
  import CardsLayout from '@/features/interface/home/tableauDeBord/cardsLayout/CardsLayout.vue'
</script>

<style scoped lang="less">
  .tasks {
    display: flex;
    height: 420px;
  }
</style>
